module.exports = __webpack_public_path__ + "static-kuaikan-h5-fe/img/kfc-intro.bb25bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/act/202010/unit_member/img/kfc-intro.png
// module id = /GN+
// module chunks = 61